import { ConfigEnvironmentModel } from "graphql/generated";

let envConfig;

try {
  // eslint-disable-next-line global-require, import/no-unresolved
  envConfig = require("../../env-config.json");
} catch (e) {
  // ignore case file not exist cause not build yet
}

export const ENV_CONFIG: ConfigEnvironmentModel = envConfig;

export const stripeCurrencyRatio = (): number => envConfig?.stripeCurrencyRatio || 1;
